module.exports = __webpack_public_path__ + "img/C-title.eeb93504.png";